import React from "react";
import "../styles/tab.scss";

const Tab = ({ title, active, onClick }) => {
  return (
    <div onClick={onClick} className={`container ${active ? "active" : ""}`}>
      <div className="text-style">{title}</div>
    </div>
  );
};
export default Tab;
